import apiClient from '@/core/api/';
const baseApiURL = 'api/account';
const baseApiLanguageURL = 'api/language';

export const signIn = async (username, password) =>
  await apiClient.post(`${baseApiURL}/login`, { username, password });

export const getForgotPasswordToken = async (userName, notify = false) =>
  await apiClient.post(`${baseApiURL}/forgotPassword/${userName}/${notify}`);

export const getUserSecurityQuestion = async (userName) =>
  await apiClient.get(`${baseApiURL}/question/username`, {
    params: {
      userName,
    },
  });

export const validateSecurityQuestion = async (userName, answer) =>
  await apiClient.post(`${baseApiURL}/question/validate`, { userName, answer });

export const validateCode = async (userId, code) =>
  await apiClient.post(`${baseApiURL}/validateCode`, { userId, code });

export const setNewPassword = async (
  userId,
  password,
  confirmPassword,
  code,
  token
) =>
  await apiClient.post(`${baseApiURL}/resetPassword`, {
    userId,
    password,
    confirmPassword,
    code,
    token,
  });

export const getLanguageByCulture = async (culture) =>
  await apiClient.get(`${baseApiLanguageURL}/${culture}`);
